import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import mediaData from "../../data/media-outreach.json";

const MediaOutreachMain = () => {
  const { mediaInterviews, pressCoverage, collegeVisits, socialOutreach } =
    mediaData;

  return (
    <div
      className="back__course__page_grid react-courses__single-page pb---16 pt---10"
      style={{ marginBottom: "70px" }}
    >
      <div className="container pb---70">
        <div className="row">
          <div className="col-lg-12">
            <Tabs>
              <div className="course-single-tab">
                <TabList className="nav nav-tabs">
                  <Tab>
                    <button>Media Interviews</button>
                  </Tab>
                  {/* <Tab>
                    <button>Press Coverage</button>
                  </Tab>
                  <Tab>
                    <button>College Visits</button>
                  </Tab>
                  <Tab>
                    <button>Social Outreach</button>
                  </Tab> */}
                </TabList>

                <div className="tab-content" id="back-tab-content">
                  {/* ---------------- MEDIA INTERVIEWS ---------------- */}
                  <TabPanel>
                    <div className="tab-pane">
                      <h3>Media Interviews</h3>
                      <p>
                        Founder interviews, UPSC strategy talks, public
                        sessions.
                      </p>

                      <div className="row mt---40">
                        {mediaInterviews.map((item, index) => (
                          <div className="col-lg-6 mb---40" key={index}>
                            {/* YOUTUBE VIDEO */}
                            <div className="course-details-video">
                              <iframe
                                width="100%"
                                height="315"
                                src={`https://www.youtube.com/embed/${item.youtubeId}`}
                                title={item.title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                            </div>

                            <h4 className="mt---15">{item.title}</h4>
                            <p>{item.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </TabPanel>

                  {/* ---------------- PRESS COVERAGE ---------------- */}
                  <TabPanel>
                    <div className="tab-pane">
                      <h3>Press Coverage</h3>

                      <div className="row mt---40">
                        {pressCoverage.map((item, index) => (
                          <div className="col-lg-6 mb---20" key={index}>
                            <div className="case-img">
                              <img src={item.image} alt="press" />
                            </div>
                            <h4 className="mt---15">{item.title}</h4>
                            <p>{item.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </TabPanel>

                  {/* ---------------- COLLEGE VISITS ---------------- */}
                  <TabPanel>
                    <div className="tab-pane">
                      <h3>College Visits</h3>

                      <div className="row mt---40">
                        {collegeVisits.map((item, index) => (
                          <div className="col-lg-6 mb---20" key={index}>
                            <div className="case-img">
                              <img src={item.image} alt="visit" />
                            </div>
                            <h4 className="mt---15">{item.title}</h4>
                            <p>{item.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </TabPanel>

                  {/* ---------------- SOCIAL OUTREACH ---------------- */}
                  <TabPanel>
                    <div className="tab-pane">
                      <h3>Social Outreach</h3>

                      <div className="row mt---40">
                        {socialOutreach.map((item, index) => (
                          <div className="col-lg-6 mb---20" key={index}>
                            <div className="case-img">
                              <img src={item.image} alt="outreach" />
                            </div>
                            <h4 className="mt---15">{item.title}</h4>
                            <p>{item.description}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaOutreachMain;
